var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('ListProduct',{attrs:{"titleProduct":_vm.titleProduct,"productType":_vm.productType,"productTypeLength":'',"iconProduct":"mdi-magnify","search":_vm.search,"isSearch":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }